<div mat-dialog-content>
  <!-- Order Cancel "Are You Sure?" section -->
  <div class="fixed inset-0 z-40 min-h-full overflow-y-auto overflow-x-hidden transition flex items-center">
    <!-- Overlay -->
    <div aria-hidden="true" class="fixed inset-0 w-full h-full bg-black/50 cursor-pointer"></div>

    <!-- Modal -->
    <div class="relative w-full cursor-pointer pointer-events-none transition my-auto p-4">
      <div
        class="w-full py-2 bg-white cursor-default pointer-events-auto dark:bg-white relative rounded-xl mx-auto max-w-sm"
      >
        <!-- Close Button -->
        <svg
          xmlns="http://www.w3.org/2000/svg"
          [mat-dialog-close]="true"
          class="w-9 h-9 flex absolute right-5"
          viewBox="0 0 24 24"
        >
          <path
            fill="purple"
            d="M12 3c-4.963 0-9 4.038-9 9s4.037 9 9 9s9-4.038 9-9s-4.037-9-9-9m0 16c-3.859 0-7-3.14-7-7s3.141-7 7-7s7 3.14 7 7s-3.141 7-7 7m.707-7l2.646-2.646a.502.502 0 0 0 0-.707a.502.502 0 0 0-.707 0L12 11.293L9.354 8.646a.5.5 0 0 0-.707.707L11.293 12l-2.646 2.646a.5.5 0 1 0 .708-.706z"
          />
        </svg>

        <!-- Ticket Form -->
        <form [formGroup]="ticketForm" (ngSubmit)="onSubmit()">
          <div class="space-y-2 p-2">
            <div class="p-4 space-y-2 text-center dark:text-black">
              <h2 class="text-xl font-bold tracking-tight" id="page-action.heading">TICKET</h2>
              <p class="text-gray-500 dark:text-black">Want to Raise a Ticket for what Reason?</p>
            </div>
          </div>

          <div class="space-y-2">
            <div aria-hidden="true" class="border-t dark:border-gray-700 px-2">
              <div class="mb-4 max-w-sm mx-auto mt-2">
                <!-- Title Field -->
                <label class="block text-gray-700 font-bold mb-2" for="title">subject</label>
                <input
                  class="shadow appearance-none border border-purple-700 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="subject"
                  type="text"
                  formControlName="subject"
                  placeholder="Enter subject"
                />
                <p
                  *ngIf="ticketForm.get('subject')?.invalid && ticketForm.get('subject')?.touched"
                  class="text-red-500 text-xs italic mt-2"
                >
                  Title is required
                </p>

                <!-- Description Field -->
                <label class="block text-gray-700 font-bold mb-2" for="description">Description</label>
                <textarea
                  class="shadow appearance-none border border-purple-700 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="description"
                  formControlName="description"
                  placeholder="Describe your issue"
                ></textarea>
                <p
                  *ngIf="ticketForm.get('description')?.invalid && ticketForm.get('description')?.touched"
                  class="text-red-500 text-xs italic mt-2"
                >
                  Description is required
                </p>

                <!-- Callback Number Field -->
                <label class="block text-gray-700 font-bold mb-2" for="callbackNumber">Callback Number</label>
                <input
                  class="shadow appearance-none border border-purple-700 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                  id="callbackNumber"
                  type="text"
                  formControlName="callbackNumber"
                  placeholder="Enter callback number"
                />
                <p
                  *ngIf="ticketForm.get('callbackNumber')?.invalid && ticketForm.get('callbackNumber')?.touched"
                  class="text-red-500 text-xs italic mt-2"
                >
                  Callback number is required
                </p>

                <!-- File Upload Field -->
                <label class="block text-gray-700 font-bold mb-2" for="files">Upload Files</label>
                <input
                  id="files"
                  type="file"
                  multiple
                  (change)="onFileSelected($event)"
                  class="shadow appearance-none border border-purple-700 rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                />
              </div>
            </div>

            <!-- Submit Button -->
            <div class="px-6 py-2">
              <div class="grid gap-2 grid-cols-[repeat(auto-fit,minmax(0,1fr))]">
                <button
                  mat-button
                  type="submit"
                  [disabled]="ticketForm.invalid || selectedFiles.length === 0"
                  class="commoncolor cursor-pointer inline-flex items-center justify-center py-1 gap-1 font-medium rounded-lg border transition-colors outline-none focus:ring-offset-2 focus:ring-2 focus:ring-inset dark:focus:ring-offset-0 min-h-[2.25rem] px-4 text-sm text-white shadow focus:ring-white border-transparent hover:bg-purple-500 focus:bg-purple-700 focus:ring-offset-purple-700"
                (click)="onNoClick()">
                  <span class="flex items-center gap-1">
                    <span class="text-white">Submit</span>
                  </span>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>